import { StringUtils } from '@blumtechgroup/blum-ui-utils';

export interface AdminUser {
  first_name: string;
  last_name: string;
  email: string;
  active: boolean;
}

export interface ValidationErrors {
  first_name: string | boolean;
  last_name: string | boolean;
  email: string | boolean;
  email_invalid: string | boolean;
}

export const validationErrors: ValidationErrors = {
  first_name: 'Please provide a first name',
  last_name: 'Please provide a last name',
  email: 'Please provide an email address',
  email_invalid: 'Please provide a valid email address',
};

export enum AdminUserReducerAction {
  FIRST_NAME,
  LAST_NAME,
  EMAIL,
  ACTIVE,
  INIT,
}

export const adminUserReducer = (state: AdminUser, action: { type: AdminUserReducerAction; value: any }): AdminUser => {
  switch (action.type) {
    case AdminUserReducerAction.FIRST_NAME:
      return { ...state, first_name: StringUtils.capitaliseFirst(action.value) };
    case AdminUserReducerAction.LAST_NAME:
      return { ...state, last_name: StringUtils.capitaliseFirst(action.value) };
    case AdminUserReducerAction.EMAIL:
      return { ...state, email: action.value?.toLowerCase() };
    case AdminUserReducerAction.ACTIVE:
      return { ...state, active: action.value };
    case AdminUserReducerAction.INIT:
      const { first_name, last_name, email, active } = action.value;
      const obj = {
        first_name,
        last_name,
        email,
        active,
      };
      return { ...(obj as AdminUser) };
    default:
      throw new Error();
  }
};
